import {
  chakra,
  forwardRef,
  type TableHeadProps as ChakraTheadProps,
} from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

import { useTableStyles } from '../TableStylesContext';
import { getClassName } from './className';

export type TheadProps = ChakraTheadProps;

export const Thead = forwardRef<TheadProps, 'thead'>(
  ({ className, ...props }, ref) => {
    const { thead: theadStyles } = useTableStyles() ?? {};

    return (
      <chakra.thead
        className={cx(getClassName('thead'), className)}
        {...props}
        ref={ref}
        __css={theadStyles}
      />
    );
  },
);
